function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M386.015,1094h-27.99a1.026,1.026,0,0,0-1.025,1.025v16.219a1.026,1.026,0,0,0,1.025,1.024h27.99a1.026,1.026,0,0,0,1.025-1.024v-16.219a1.026,1.026,0,0,0-1.025-1.025Zm-27.253,2.525,8.42,5.6-8.42,7.329Zm13.258,6.7-11.222-7.459h22.443Zm-3.316-.089,2.749,1.827a1.021,1.021,0,0,0,1.134,0l2.749-1.827,8.472,7.375H360.231Zm8.154-1.011,8.419-5.6v12.926Zm0,0",
  transform: "translate(-357 -1094)",
  fill: "#cdcdcd"
});

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.04,
    height: 18.269,
    viewBox: "0 0 30.04 18.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.1c400c24.svg";
export { ForwardRef as ReactComponent };